<template>
  <v-list id="js-nav-menu-list" :dense="false">
    <v-list-item
      @click="$router.push({ name: 'dashboardMentor', params: { id: userId } })"
    >
      <v-list-item-icon>
        <v-icon>mdi-home</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Home</span>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      @click="
        $router.push({ name: 'detailsMentorView', params: { id: userId } })
      "
    >
      <v-list-item-icon>
        <v-icon>mdi-account-details</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        Mentee Profile
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      @click="
        $router.push({ name: 'coursesGridMentor', params: { id: userId } })
      "
    >
      <v-list-item-icon>
        <v-icon>mdi-school</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        Learning Resources
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      @click="
        $router.push({ name: 'MemberAssessments', params: { id: userId } })
      "
    >
      <v-list-item-icon>
        <v-icon>mdi-certificate-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        Assessments
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      @click="
        $router.push({ name: 'documentsListMentor', params: { id: userId } })
      "
    >
      <v-list-item-icon>
        <v-icon>mdi-file-document-box-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        Documents
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      @click="$router.push({ name: 'memberMessages', params: { id: userId } })"
    >
      <v-list-item-icon>
        <v-icon>mdi-cellphone-iphone</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        Text Messaging
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      @click="
        $router.push({ name: 'systemMessageMentor', params: { id: userId } })
      "
    >
      <v-list-item-icon>
        <v-icon>mdi-bell</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        System Messaging
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  computed: {
    userId: {
      get() {
        return this.$store.state.globals.menteeId
      },
      set(value) {
        this.$store.commit("globals/setMenteeId", value)
      }
    }
  }
}
</script>
